import React from "react";
import { imageHero } from "../../../assets";
import Typed from "react-typed";

const HeroSection = () => {
    return (
        <div className="flex lg:mb-20 justify-center lg:pt-40">
            <div className="container lg:flex">
                <div className="lg:w-3/5 text-start my-auto pt-40 lg:pt-32 px-8 lg:px-0 lg:pr-4" data-aos="fade-right">
                    <h1 className="text-4xl lg:text-5xl font-normal font-header text-green-800 leading-relaxed">Nikmati liburanmu <span className="">dengan berwisata di</span> <br />
                    </h1>
                    <h1 className="text-fifth text-4xl lg:text-5xl my-4 font-header">
                        <Typed
                            loop
                            typeSpeed={90}
                            backSpeed={90}
                            strings={["Pulau Gili Iyang"]}
                            smartBackspace
                            shuffle={false}
                            backDelay={1}
                            fadeOut={false}
                            fadeOutDelay={200}
                            loopCount={0}
                            showCursor
                            cursorChar=""
                        />{" "}
                        👋
                    </h1>
                    <p className="text-lg lg:text-2xl py-4">Maksimalkan waktu liburan dengan eksplorasi Pulau Gili Iyang. Kami menyediakan berbagai paket ekowisata yang menyajikan berbagai hal tentang pulau ini dengan melakukan berbagai eksplorasi wisata alam, budaya, religi dan hal - hal menarik lainnya di pulau ini.</p>
                </div>
                <div className=" md:w-4/5 lg:w-2/5 my-auto" data-aos="fade-left">
                    <div className="flex justify-center lg:justify-end">
                        <img src={imageHero} className="w-full" alt="" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HeroSection;